module.exports = __webpack_public_path__ + "img/offline3.033b8337.svg";